import React from 'react';
import { VEHICLE_CATALOGUE, formatCapacity } from '../../../config/rateCard';

/**
 * "Will it fit?" — the fleet table from Redesign v2.
 *
 * Capacities come from the rate card rather than a second list, so a vehicle can
 * never advertise one payload here and another in the estimate widget.
 *
 * The table shows the whole catalogue but marks what can be booked today, which
 * is the Bakkie alone. The alternative — listing only the Bakkie — would have
 * shrunk the section to a single cell and hidden a fleet that is genuinely
 * arriving. Marking rather than hiding follows the pattern the site already uses
 * for coverage cities and for web booking: name the thing, say plainly that it
 * is not live yet, and never let it look orderable.
 *
 * The estimate widget stays stricter and prices only bookable classes — you can
 * read about a 14-ton truck here, but you cannot be quoted for one.
 */

const FleetSection: React.FC = () => {
  return (
    <>
      <hr className="sw-lane-rule" aria-hidden="true" />

      <section className="sw-section" id="vehicles">
        <div className="container">
          <div className="sw-section-head">
            <span className="sw-eyebrow">The fleet</span>
            <h2>Will it fit?</h2>
            <p>
              The question that actually stalls a booking. Here is what each vehicle takes, in
              kilograms and in plain examples. Bakkie bookings are live today; the larger classes
              are rolling out.
            </p>
          </div>

          <div className="sw-spec-table">
            {VEHICLE_CATALOGUE.map((vehicle) => (
              <div className="sw-spec-cell" key={vehicle.vehicleType}>
                <span className="sw-spec-name">{vehicle.label}</span>
                <span className="sw-spec-capacity">{formatCapacity(vehicle.capacityKg)}</span>
                <p className="sw-spec-desc">{vehicle.example}</p>
                {vehicle.bookable ? (
                  <span className="sw-pill sw-pill-live">Book now</span>
                ) : (
                  <span className="sw-pill sw-pill-quiet">Coming soon</span>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default FleetSection;
